import React, { useState } from 'react';
import PickAndPackContext from './PickAndContext';
import { getCurrenciesDenominationsByCustomer } from '../../../networking/NetworkingCurrencies';
import { getBankNoteOrder } from '../../../networking/NetworkingBankNotes';
import useLookUpTables from '../../maintenance/complaints/useLookUpTables';
import { useEffect } from 'react';
import { getRolesByUsername } from '../../../networking/NetworkingRoles';
import { getBNVaultBalances } from '../../../networking/NetworkingOrders';
import AlertBox from '../../shared/AlertBox';
import LoadingBox from '../../shared/LoadingBox';

const BANKNOTES_ADMIN = 'BankNotesAdmin'
const BANKNOTES_INVENTORYBALANCES = 'BankNotesInventoryBalances'


const PickAndPackProvider = ({ children }) => {

  const [bankNoteOrder, setBankNoteOrder] = useState({});
  const [customerDenominations, setCustomerDenominations] = useState([]);
  const [lockedSide, setLockedSide] = useState('');
  const [sellDeliveryStatusOptions, setSellDeliveryStatusOptions] = useState([]);
  const [buyDeliveryStatusOptions, setBuyDeliveryStatusOptions] = useState([]);
  const [isBankNotesAdmin, setIsBankNotesAdmin] = useState(false)
  const [canViewInventoryBalances, setCanViewInventoryBalances] = useState(false)
  const [vaultBalances, setVaultBalances] = useState([])
  const [loading, setLoading] = useState(false)
  const [reviewPurchaseOrders, setReviewPurchaseOrders] = useState(false)
  const [toSetAsReceivedManually, setToSetAsReceivedManually] = useState(false)
  const [reviewAndAuthorizeSellOrders, setReviewAndAuthorizeSellOrders] = useState(false)
  const [confirmationMessage, setConfirmationMessage] = useState({ show: false, title: '', message: '', callback: null, callbackParams: [] })    
  const [eodIsValid, setEodIsValid] = useState(true)
  const [serverDate, setServerDate] = useState(localStorage.getItem('ServerDate') ?? '')  
  const [systemDate, setSystemDate] = useState(localStorage.getItem('BNSystemDate') ?? '')  

  const lookUpTables = useLookUpTables('BN Delivery Buy Status,BN Delivery Sell Status');

  useEffect(() => {
    const loadRoles = async () => {
      getRolesByUsername('ForeignExchange', localStorage.getItem('UserName')).then(
        (response) => {
          console.log('loadRoles ', response)
          if (response && Array.isArray(response) && response.map(e => e.toLowerCase()).includes(BANKNOTES_ADMIN.toLowerCase())) {
            setIsBankNotesAdmin(true)
          }
          else {
            setIsBankNotesAdmin(false)
          }
          if (response && Array.isArray(response) && response.map(e => e.toLowerCase()).includes(BANKNOTES_INVENTORYBALANCES.toLowerCase())) {
            setCanViewInventoryBalances(true)
          }
          else {
            setCanViewInventoryBalances(false)
          }
        }
      )
    }

    loadRoles();

    const systemDate = localStorage.getItem('BNSystemDate') ?? '';
    const serverDate = localStorage.getItem('ServerDate');
    const systemDateObj = new Date(systemDate.replaceAll('-', '/'));
    const serverDateObj = new Date(serverDate);

    if (systemDateObj.getFullYear() !== serverDateObj.getFullYear() || systemDateObj.getMonth() !== serverDateObj.getMonth() || systemDateObj.getDate() !== serverDateObj.getDate()) {
      setEodIsValid(false);
    }

  }, [])

  const getBankOrder = async (orderId) => {
    const order = await getBankNoteOrder(orderId)
    console.log('order ', order)
    if (order && order.CustomerId > 0) {

      setBankNoteOrder(order)
      const currenciesResponse = await getCurrenciesDenominationsByCustomer(order.CustomerId)
      console.log('currenciesResponse ', currenciesResponse)

      if (currenciesResponse && currenciesResponse.currencies) {
        setCustomerDenominations(currenciesResponse.currencies);
      }

      if (order.VaultID && order.VaultID > 0) {
        setLoading(true)
        const balancesResponse = await getBNVaultBalances({ vaultId: order.VaultID });
        setLoading(false)
        let balances = []
        if (balancesResponse && Array.isArray(balancesResponse.result) && balancesResponse.result.length > 0) {
          const balances = balancesResponse.result
          setVaultBalances(balances) // set balances in context for use in form and to avoid calling API again when needed                        
        } else {
          setVaultBalances([]) // set empty to avoid issues in form if API call fails or returns no data
        }
      }
    }
    else {
      setBankNoteOrder({});
      setCustomerDenominations([]);
      setVaultBalances([]) 
    }
  }

  const onYesToConfirmationMessage = () => {
    if (confirmationMessage.callback !== null) {
      confirmationMessage.callback(...confirmationMessage.callbackParams)
      setConfirmationMessage({ ...confirmationMessage, show: false, title: '', message: '', callbac: null })
    }
  }

    return (
      <PickAndPackContext.Provider
        value={{
          lockedSide,
          setLockedSide,
          bankNoteOrder,
          setBankNoteOrder,
          getBankOrder,
          customerDenominations,
          lookUpTables,
          sellDeliveryStatusOptions,
          setSellDeliveryStatusOptions,
          buyDeliveryStatusOptions,
          setBuyDeliveryStatusOptions,
          isBankNotesAdmin,
          canViewInventoryBalances,
          setCanViewInventoryBalances,
          vaultBalances,
          reviewPurchaseOrders,
          setReviewPurchaseOrders,
          toSetAsReceivedManually,
          setToSetAsReceivedManually,
          reviewAndAuthorizeSellOrders,
          setReviewAndAuthorizeSellOrders,
          confirmationMessage,
          setConfirmationMessage,
          eodIsValid,
          serverDate,
          systemDate,
          loading,
          setLoading
        }}
      >
        <LoadingBox loading={loading} />
        {children}
         <AlertBox id="rc-confirmMessage" open={confirmationMessage.show} title={confirmationMessage.title} message={confirmationMessage.message} type="Yes/No"
                yesClick={() => onYesToConfirmationMessage()}
                onClose={() => setConfirmationMessage({ ...confirmationMessage, show: false, title: '', message: '', callback: null, callbackParams: [] })}
                noClick={() => setConfirmationMessage({ ...confirmationMessage, show: false, title: '', message: '', callback: null, callbackParams: [] })}
              /> 
      </PickAndPackContext.Provider>
    );
};

export default PickAndPackProvider;